module.exports = __webpack_public_path__ + "img/hub-iso.b7b312cb.jpg";